import { Measure, useModelService } from 'services/model/model.service';
import { InfoContentItem } from './InfoContentItem';

export function MeasureInfoContentItem({
  measure,
  isOrderDate = true,
  highlighted = false,
}: {
  measure: Measure;
  isOrderDate?: boolean;
  highlighted?: boolean;
}) {
  const { getMeasureDetails } = useModelService();
  const measureDetails = getMeasureDetails(measure, isOrderDate);

  return (
    <InfoContentItem
      title={measureDetails.longName}
      description={measureDetails.metric.description}
      highlighted={highlighted}
      measure={measure}
    />
  );
}
